module.exports = __webpack_public_path__ + "static/media/logo-with-slogan.e56803e6.png";